import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { useActions } from '../../../../../../shared/hooks';
import { getOtherRecordingParticipants, isLocalRecordingActive } from '../../../../selectors';
import { recordConferenceAction, stopRecordConferenceAction } from '../../../record/slice';
import { ToolbarOption } from '../../toolbar-option';

export function LocalRecordingOption() {
    const isRecording = useSelector(isLocalRecordingActive);

    const { start, stop } = useActions({
        start: recordConferenceAction,
        stop: stopRecordConferenceAction,
    });

    const props = useMemo(() => {
        if (isRecording) {
            const content = i18n('toolbar', 'local-recording-stop');

            return {
                content: content,
                title: content,
                iconName: 'pulseRecordingDot',
                onClick: () => {
                    stop();
                    countMetrika('meeting_screen', 'toolbar', 'local_recording_stop');
                },
            } as const;
        } else {
            const content = i18n('toolbar', 'local-recording-start');

            return {
                content: content,
                title: content,
                iconName: 'record',
                onClick: () => {
                    start();
                    countMetrika('meeting_screen', 'toolbar', 'local_recording_start');
                },
            } as const;
        }
    }, [isRecording, start, stop]);

    const isOtherRecordingParticipants = useSelector(getOtherRecordingParticipants);
    const otherRecordingDotColor = isOtherRecordingParticipants.length > 0 ? 'red' : undefined;

    return <ToolbarOption {...props} dotColor={otherRecordingDotColor} />;
}
